import React, { useRef } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { CgSearchLoading } from "react-icons/cg";
import { IoMdCloseCircle } from "react-icons/io"; // Icon cho nút Clear
import { Spinner } from "react-bootstrap";

const SearchBox = ({ onSubmit, isSearching, searchValue, setSearchValue }) => {
  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchValue.trim()) return;
    onSubmit(searchValue.trim()); // Chỉ trigger khi submit
    document.activeElement.blur();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const value = (e.clipboardData || window.clipboardData).getData("text");
    setSearchValue(value);
  };

  // *** Xử lý Clear Input ***
  const handleClear = () => {
    setSearchValue("");
    // Đặt lại focus vào ô input sau khi xóa
    if (formRef.current) {
      formRef.current.querySelector('input[type="text"]').focus();
    }
  };
  // *************************

  return (
    <form
      className="search-form-modern d-flex"
      onSubmit={handleSubmit}
      ref={formRef}
    >
      {/* Div bọc input và clear button để định vị icon */}
      <div className="input-wrapper d-flex flex-grow-1 position-relative">
        <input
          type="text"
          placeholder="Dán link YouTube cần tải xuống"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onPaste={handlePaste}
          required
        />

        {/* *** Nút Clear *** */}
        {searchValue && ( // Chỉ hiển thị khi searchValue có giá trị
          <button
            type="button" // QUAN TRỌNG: Ngăn form submit khi nhấn nút này
            className="clear-button"
            onClick={handleClear}
            disabled={isSearching}
          >
            <IoMdCloseCircle size={20} />
          </button>
        )}
        {/* ******************* */}
      </div>

      <button
        type="submit"
        disabled={!searchValue || isSearching}
        className="d-flex align-items-center justify-content-center gap-2"
        style={{
          minWidth: "120px",
        }}
      >
        {!isSearching ? (
          <>
            <BiSearchAlt size={20} />
            Search
          </>
        ) : (
          <>
            <CgSearchLoading size={20} className="spin" />
            <Spinner animation="grow" size="sm" className="size-mn" />
            <Spinner animation="grow" size="sm" className="size-mn" />
            <Spinner animation="grow" size="sm" className="size-mn" />
          </>
        )}
      </button>
    </form>
  );
};

export default SearchBox;
